import { search } from "../../../BaseRepositoryComponents";

const searchParams = new URLSearchParams(window.location.search);
const path = `${process.env.REACT_APP_URL_API_REPORTS}/invoicingmirror`;

const headers = new Headers();
const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findDashboardRecurrentServiceContract(filterProps) {
  const url = new URL(`${path}/dashboard/recurrentservicecontract`);
  Object.entries(filterProps).forEach(([key, value]) => {
    if (value && !value?.toString().startsWith("no-")) {
      url.searchParams.append(key, value);
    }
  });

  return search(decodeURIComponent(url), "GET", headers);
}
